import { Injectable, inject } from '@angular/core';
import { FetchPrecarityTaxRevenueResponseModel, PrecarityService } from '@effy-tech/angular-common/precarity-level';
import { Observable } from 'rxjs';
import { LocationValues } from '../../values/location.values';

@Injectable({
  providedIn: 'root',
})
export class PrecarityLevelService {
  private readonly PROVINCE_ZIPCODE = '55100'; // Province - Reims chosen arbitrarily
  private readonly ILE_DE_FRANCE_ZIPCODE = '75015'; // Ile-de-France - Paris chosen arbitrarily
  private readonly precarityService = inject(PrecarityService);

  getPrecarityLevel(location: LocationValues, houseHoldSize: number): Observable<FetchPrecarityTaxRevenueResponseModel> {
    return this.precarityService.fetchTaxRevenue({
      household_size: houseHoldSize.toString(),
      zipcode: this.getDepartmentFromLocation(location),
      referencial: '4levels',
    });
  }

  private getDepartmentFromLocation(location: LocationValues): string {
    return location === LocationValues.OtherRegions ? this.PROVINCE_ZIPCODE : this.ILE_DE_FRANCE_ZIPCODE;
  }
}
